import React from "react";
import { MenuItem, TextField } from "@mui/material";

const FilterBar = ({ categories, selectedCategory, setSelectedCategory }) => {
  return (
    <TextField
      select
      label="Filter by Category"
      value={selectedCategory}
      onChange={(e) => setSelectedCategory(e.target.value)}
      fullWidth
      sx={{
        marginBottom: "20px",
        width: "200px",
        height: "40px",
        fontSize: "12px",
        "& .MuiInputBase-root": {
          height: "32px",
          fontSize: "12px",
        },
        "& .MuiSelect-select": {
          padding: "6px 12px",
          fontSize: "12px",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#ccc",
          },
          "&:hover fieldset": {
            borderColor: "#999",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#666",
          },
        },
      }}
    >
      <MenuItem value="All">All</MenuItem>
      {categories.map((category, index) => (
        <MenuItem key={index} value={category}>
          {category}
        </MenuItem>
      ))}
    </TextField>
  );
};
export default FilterBar;
